module.exports = __webpack_public_path__ + "assets/750293874e693035c71d3541b963de34.jpg";